<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 position-fixed background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto">
            <div class="fs-main text-center color-white">Signal-strength analysis</div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar mt-5 gap-3">
        <div class="d-flex justify-content-center pt-5">
            <ngb-datepicker #dp
                            (dateSelect)="onDateSelection($event)"
                            [classList]="'justify-content-center'"
                            [dayTemplate]="t"
                            [displayMonths]="1"
                            [maxDate]="today"
                            [startDate]="today"
                            class="row d-flex justify-content-center align-items-center"
                            outsideDays="hidden"></ngb-datepicker>
            <ng-template #t let-date>
                <span (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null"
                    [class.faded]="(isInSelectedRange(date) || isInHoveredRange(date)) && isValidRange()"
                    [class.range]="isStartOrEndOfRange(date)"
                    class="custom-day">
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
        @if (!overlayShown) {
            <app-generic-button
                (click)="showOverlay()"
                description="Search signal-strength data"
                [alwaysShowText]="true"
                [buttonText]="'Search'"
                [disabled]="loading || overlayShown || !fromDate"
                [loading]="loading"
                [primaryIcon]="'fa fa-magnifying-glass'"/>
        } @else {
            <app-generic-button
                (click)="reset()"
                description="Reset range for signal-strength analysis"
                [alwaysShowText]="true"
                [buttonText]="'Reset'"
                [disabled]="loading || !overlayShown"
                [loading]="loading"
                [primaryIcon]="'fa fa-recycle'"/>
        }
        <div class="dropdown">
            <button [disabled]="signalStrengthAnalysisStore.loading()"
                    class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#gatewayFilterDropDown"
                    type="button">
                {{ selectedGateway()?.name || "Filter by gateway" }}
            </button>
            <div class="collapse w-100" id="gatewayFilterDropDown">
                    <div (click)="onGatewayFilterSelection()"
                        class="btn card m-1"
                        data-bs-target="#gatewayFilterDropDown"
                        data-bs-toggle="collapse">Clear filter
                    </div>
                @for (gateway of gateways(); track gateway.id) {
                    <div (click)="onGatewayFilterSelection(gateway)"
                        class="btn card m-1"
                        data-bs-target="#gatewayFilterDropDown"
                        data-bs-toggle="collapse">{{ gateway.name }}
                    </div>
                }
            </div>
        </div>
        <app-generic-button
            (click)="onNavigateToSelectedGateway()"
            description="Center map on selected gateway"
            [alwaysShowText]="true"
            buttonText="Center map on selected gateway"
            [disabled]="signalStrengthAnalysisStore.loading() || !selectedGateway()"/>
    </div>
</div>
